(function () {
  var STORAGE_KEY = 'dt_recently_viewed';
  var MAX_STORED = 24;

  function readHistory() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeHistory(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function recordView(handle) {
    if (!handle) return;
    var list = readHistory().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    if (list.length > MAX_STORED) list = list.slice(0, MAX_STORED);
    writeHistory(list);
  }

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCard(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    return (
      '<li class="recently-viewed__item">' +
        '<a href="' + escapeHtml(p.url) + '" class="recently-viewed__link">' +
          (img ? '<img src="' + escapeHtml(img + '&width=400') + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="200" height="200">' : '') +
          '<span class="recently-viewed__title">' + escapeHtml(p.title) + '</span>' +
          '<span class="recently-viewed__price">' + formatMoney(p.price) + '</span>' +
        '</a>' +
      '</li>'
    );
  }

  function initSection(el) {
    var currentHandle = el.dataset.currentHandle;
    if (currentHandle) recordView(currentHandle);

    var limit = parseInt(el.dataset.limit, 10) || 6;
    var handles = readHistory()
      .filter(function (h) { return h !== currentHandle; })
      .slice(0, limit);
    if (!handles.length) return;

    Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + h + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) return;
      var list = el.querySelector('.recently-viewed__grid');
      if (!list) return;
      list.innerHTML = products.map(renderCard).join('');
      el.hidden = false;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('recently-viewed-products').forEach(initSection);
  });
})();
